<template>
  <div id="app" class="min-h-screen bg-primary-500">
    <div class="container mx-auto px-6 lg:px-8">
      <div class="flex justify-center">
        <div class="max-w-xl w-full py-6">
          <div class="flex text-center items-center justify-center mb-4">
            <img
              src="./assets/img/cissa-logo-white.png"
              alt="cissa-logo"
              class="w-16 h-16 lg:w-24 lg:h-24"
            />
            <h2 class="text-white text-xl lg:text-3xl text-center px-2">
              "NATAI MEDICAL CENTER & RESORT"
            </h2>
          </div>
          <p class="text-gray-300 text-center py-2">
            World class Medical and wellness Tourist destination at Natai Beach Resort & Spa
            Phangnga
          </p>
          <div class="mt-2">
            <RegisterForm />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegisterForm from './components/RegisterForm';
export default {
  name: 'App',
  components: {
    RegisterForm,
  },
  metaInfo: {
    title: 'Registration for "NATAI MEDICAL CENTER & RESORT"',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content:
          'Registration for "NATAI MEDICAL CENTER & RESORT" World class Medical and wellness Tourist destination at Natai Beach Resort & Spa Phangnga',
      },
    ],
  },
};
</script>

<style src="./assets/css/tailwind.css"></style>
<style>
.btn-default {
  @apply rounded bg-gray-300 text-gray-800 font-bold py-2 px-4;
}
.btn-default:hover {
  @apply bg-gray-100;
}
.btn-default:disabled {
  @apply opacity-50 text-gray-500 cursor-not-allowed;
}
.btn-primary {
  @apply bg-primary-500 text-white font-bold py-2 px-4;
}
.btn-primary:hover {
  @apply bg-primary-700;
}
.btn-primary:disabled {
  @apply opacity-50 cursor-not-allowed;
}
.swal-button {
  padding: 7px 19px;
  border-radius: 2px;
  background-color: #405d65;
  font-size: 12px;
  border: 1px solid #3a545b;
  text-shadow: 0px -1px 0px rgba(0, 0, 0, 0.3);
}
</style>
